// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-smallOnWide-badge-85b15530"};